import React, { useEffect, useState } from 'react';
import 'styles/components/menu/company/CITab.scss';
import CI_black from 'assets/images/company/CI_black.png';
import CI_white from 'assets/images/company/CI_white.png';
import styled from 'styled-components';

const Img = styled.div`
    width: 100%;
    height: 0;
    padding-top: calc(230 / 570 * 100%);
    background : url(${props => props.src}) center left / cover no-repeat;
    margin-bottom: 2rem;
`;

const CITab = () => {

    const [moreThan768, setMoreThan768] = useState(window.innerWidth >= 768 ? true : false); //창 너비 768px 기준 true/false 반환

    const handleMoreThan768 = () => {
        const winSize = window.innerWidth;

        if (winSize >= 768) {
            setMoreThan768(true);
        } else {
            setMoreThan768(false);
        }
    }
    useEffect(() => {
        window.addEventListener('resize', handleMoreThan768);
        return () => {
            window.removeEventListener('resize', handleMoreThan768);
        }
    }, []);

    return (
        <section className='CITab'>
            {moreThan768 ? (
                <div className="CITab-wrapper">
                    <div className="logos">
                        <Img src={CI_white} />
                        <Img src={CI_black} />
                        <div className="logos-download">
                            <button className="logos-AI">AI Download</button>
                            <button className="logos-JPG">JPG Download</button>
                            <button className="logos-PNG">PNG Download</button>
                        </div>
                    </div>
                    <div className="content">
                        <div className="citab-title"><span className="fw-bold">C</span>OPERATE<br className='lineBreak' /><span className="fw-bold">I</span>DENTITY</div>
                        <div className="color-box">
                            <div className="color-title">Main Color</div>
                            <div className="color-wrapper-blue">
                                <div className="color-blue">#2A3285</div>
                                <div className="blue-text">
                                    <div>
                                        <p className="fw-bold">CMYK</p>
                                        <p>
                                            <span>C96</span>
                                            <span>M93</span>
                                            <span>Y19</span>
                                            <span>K0</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p className="fw-bold">RGB</p>
                                        <p>
                                            <span>R42</span>
                                            <span>G50</span>
                                            <span>B133</span>
                                            <span></span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="color-wrapper-red">
                                <div className="color-red">#E12126</div>
                                <div className="red-text">
                                    <div>
                                        <p className="fw-bold">CMYK</p>
                                        <p>
                                            <span>C13</span>
                                            <span>M96</span>
                                            <span>Y88</span>
                                            <span>K0</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p className="fw-bold">RGB</p>
                                        <p>
                                            <span>R225</span>
                                            <span>G33</span>
                                            <span>B38</span>
                                            <span></span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="CITab-wrapper-m">
                    <div className="citab-title-m"><span className="fw-bold">C</span>OPERATE < br className='lineBreak' /> <span className="fw-bold">I</span>DENTITY</div >
                    <div className="logos-m">
                        <Img src={CI_white} />
                        <Img src={CI_black} />
                        <div className="logos-download-m">
                            <button className="logos-AI-m">AI Download</button>
                            <button className="logos-JPG-m">JPG Download</button>
                            <button className="logos-PNG-m">PNG Download</button>
                        </div>
                    </div>
                    <div className="color-box-m">
                        <div className="color-title-m">Main Color</div>
                        <div className="color-wrapper-blue-m">
                            <div className="color-blue-m">#2A3285</div>
                            <div className="blue-text-m">
                                <div>
                                    <p className="fw-bold">CMYK</p>
                                    <p>
                                        <span>C96</span>
                                        <span>M93</span>
                                        <span>Y19</span>
                                        <span>K0</span>
                                    </p>
                                </div>
                                <div>
                                    <p className="fw-bold">RGB</p>
                                    <p>
                                        <span>R42</span>
                                        <span>G50</span>
                                        <span>B133</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="color-wrapper-red-m">
                            <div className="color-red-m">#E12126</div>
                            <div className="red-text-m">
                                <div>
                                    <p className="fw-bold">CMYK</p>
                                    <p>
                                        <span>C13</span>
                                        <span>M96</span>
                                        <span>Y88</span>
                                        <span>K0</span>
                                    </p>
                                </div>
                                <div>
                                    <p className="fw-bold">RGB</p>
                                    <p>
                                        <span>R225</span>
                                        <span>G33</span>
                                        <span>B38</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            )}
        </section >
    );
};

export default React.memo(CITab);